
import { ImmutableStore } from 'fluxible-immutable-utils';
import Actions from '../constants/Actions';

class ContactMeStore extends ImmutableStore {
  static storeName = 'ContactMeStore';

  static handlers = {
    [Actions.CONTACT_LEAD_UPDATED]: 'handleContactLeadUpdate',
    [Actions.ZIPCODE_UPDATED]: 'handleZipCodeUpdate',
    [Actions.CHANGE_CONTACT_SCREEN]: 'handleScreenChange',
    [Actions.MAP_LOCATION_SELECTED]: 'handleMapLocationSelect',
    [Actions.APPOINTMENT_TIME_SELECTED]: 'handleAppointmentTimeSelect'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.setState({
      selectedScreen: 'contact',
      processing: false,
      allowEdit: true,
      lead: {},
      selectedLocation: false,
      selectedTime: false,
      zipCode: {}
    });
  }

  handleContactLeadUpdate(lead) {
    this.mergeState({
      lead
    });
  }

  handleZipCodeUpdate(zipCodeForm) {
    this.mergeState({
      zipCode: zipCodeForm
    });
  }

  handleScreenChange(selectedScreen) {
    this.mergeState({
      selectedScreen
    });
  }

  handleMapLocationSelect(selectedLocation) {
    this.mergeState({
      selectedLocation,
      selectedTime: false
    });
  }

  handleAppointmentTimeSelect(selectedTime) {
    this.mergeState({
      selectedTime
    });
  }

  getLead() {
    const lead = this.get('lead');
    return lead ? lead.toJS() : {};
  }

  getZipCode() {
    const zipCodeForm = this.get('zipCode');
    return zipCodeForm ? zipCodeForm.toJS() : {};
  }

  getSelectedScreen() {
    return this.get('selectedScreen');
  }

  getSelectedLocation() {
    const location = this.get('selectedLocation');
    return location ? location.toJS() : {};
  }

  getSelectedTime() {
    const time = this.get('selectedTime');
    return time ? time.toJS() : {};
  }
}

export default ContactMeStore;



/** WEBPACK FOOTER **
 ** ./src/main/js/contactMe/stores/ContactMeStore.js
 **/